module.exports = __webpack_public_path__ + "media/images/session-background-3f7b44b2e5a1ac03f9e8d6c41fffbd20.png";